module.exports = __webpack_public_path__ + "static/media/Milk_lite4.ccebf76f.jpg";